import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AppAnnounce } from '../../models/app';

import { AppStore } from '../../store';
import { AppService, PostMessageService } from '../../services/app';

@Component({
  selector: 'app-announce',
  templateUrl: './announce.component.html',
  imports: [NgTemplateOutlet],
})
export class AnnounceComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];
  private _appStore = inject(AppStore);
  private _appService = inject(AppService);
  private _content = viewChild<TemplateRef<any>>('content');
  private _postMessageService = inject(PostMessageService);
  private _modalService = inject(NgbModal);
  readonly appAnnounce = signal<AppAnnounce | null>(null);

  ngOnInit(): void {
    this._subscriptions$.push(
      this._appService.showAnnounce$.subscribe((announce) => {
        if (announce) {
          this.open(announce);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this._subscriptions$.forEach((s) => s?.unsubscribe());
    this._subscriptions$ = [];
  }

  open(announce: AppAnnounce): NgbModalRef {
    this._postMessageService.postMessageScrollIntoView();
    this.appAnnounce.set(announce);

    const modalRef = this._modalService.open(this._content(), {
      backdrop: announce.static ? 'static' : true,
      size: announce.size ?? 'sm',
    });
    modalRef.result.then(
      (result) => {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
      },
      (reason) => {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
      },
    );

    this._appStore.updateAnnounceRef(modalRef);
    return modalRef;
  }
}
